/* Overrides for the Powerful Form Builder app (Globo), loaded with the theme layout.
   The app renders its e-mail field as type="text", marked only by data-type, and forms whose stored
   HTML predates the app's autocomplete tokens have no autocomplete at all. WBWEBS-2173 asks for
   type="email" and autocomplete="email" on every e-mail field so that browsers and password managers
   treat it as a contact e-mail field. The app has no setting for either attribute, so this script sets
   them whenever the app inserts form markup (embedded forms, popups and every re-render).
   Remove it once the app renders both attributes itself. */
(function () {
  function fixEmailInputs() {
    // Only fields that lack type="email" or autocomplete="email", so the observer never rewrites
    // the attributes of a field the user is typing in when the app inserts an error message.
    document.querySelectorAll('.globo-formbuilder input[data-type="email"]:not([type="email"][autocomplete="email"])').forEach((input) => {
      input.setAttribute('type', 'email');
      input.setAttribute('autocomplete', 'email');
    });
  }

  // The app inserts and re-inserts its form markup with innerHTML, so watch added nodes instead of
  // relying on its undocumented globo.formbuilder.form.loaded event, which fires only when its init completes.
  new MutationObserver(fixEmailInputs).observe(document.documentElement, { childList: true, subtree: true });
  fixEmailInputs();
})();
